export const light = {
  white: '#ffffff',
  white2: 'rgba(255,255,255,0.2)',
  white3: 'rgba(255,255,255,0.7)',

  black: '#000000',
  black2: '#rgba(0,0,0,.5)',
  black3: '#rgba(0,0,0,0.05)',
  black4: '#rgba(0,0,0,0.85)',

  gray23: '#333333',
  gray21: '#7f7f7f',
  gray22: '#cccccc',
  gray7: '#f2f2f2',

  red1: '#F4354C',

  yellow1: '#ffa000',
  yellow2: '#ffbc03',
  yellow3: '#ea830d',

  green1: '#59c891',
  green2: '#00a846',
  green11: 'rgba(89, 200, 145, 0.8)',

  blue1: 'rgba(2, 131, 255, 1)',
  blue4: 'rgba(2, 131, 255, 0.5)',
  blue8: 'rgba(2, 131, 255, 0.1)',
  blue9: '#503ae7',
  blue11: '#32b0cf',
  blue12: '#dcf6ff',
  blue13: 'rgba(255,255,255,0.2)',
  blue2: 'rgba(243, 247, 253, 1)',

  transparent: 'transparent',
};

export const dark = {
  white: '#1b1b31', // card background
  white2: 'rgba(27,27,49,0.2)',
  white3: 'rgba(27,27,49,0.7)',

  black: '#ffffff',
  black2: '#rgba(255,255,255,.5)',
  black3: '#rgba(255,255,255,0.05)', // divider
  black4: '#rgba(255,255,255,0.85)',

  gray23: '#cccccc', // title
  gray21: '#7f7f7f', // description
  gray22: '#cccccc',
  gray7: '#141528',

  red1: '#F4354C',

  yellow1: '#ffa000',
  yellow2: '#ffbc03',
  yellow3: '#ea830d',

  green1: '#59c891',
  green2: '#00a846',
  green11: 'rgba(89, 200, 145, 0.8)',

  blue1: 'rgba(2, 131, 255, 1)',
  blue4: 'rgba(2, 131, 255, 0.5)',
  blue8: 'rgba(2, 131, 255, 0.1)',
  blue9: '#503ae7',
  blue11: '#32b0cf',
  blue12: '#dcf6ff',
  blue13: 'rgba(255,255,255,0.2)',
  blue2: '#141528', // background

  transparent: 'transparent',
};

/** @typedef {light} Colors */
